import store from '../store/store'
import axios from 'axios'

export default class ConnectionService {
  responseInTime ({responseObject, value, status}) {
    responseObject[value] = status
    setTimeout(() => {
      return responseObject[value] = status === true || status === false ? !status : undefined;
    }, 4000)
  }
}





